/** 영역별 메뉴 — 화면 숨김은 편의다. 강제는 서버(계약 access·범위 필터·toView·영역 쿠키)가 한다 */
/** 사용자 영역 (/app) — 브랜드 여럿을 관리하는 계정도 같은 메뉴다(261013-account-brand-membership) */
export const APP_NAV = [
  // ★ 제목("{브랜드명} AI검색 최적화 보고서")과 같은 것을 가리킨다 — 탭과 제목이 다른 이름이면 다른 화면으로 읽힌다.
  //   운영자 영역의 '노출 현황'(ADMIN_NAV)은 그대로다. 그쪽은 브랜드 하나의 보고서가 아니라 전체 표다
  { to: '/app/report', label: '보고서' },
  { to: '/app/articles', label: '기사 검토' },
  { to: '/app/brands', label: '브랜드' },
  { to: '/app/billing', label: '구독 관리' },
] as const satisfies readonly { to: string; label: string }[];

/** 운영자 영역 (/admin) — 수집 상태·워커는 장애 대응에서 늘 함께 본다 */
export const ADMIN_NAV = [
  { group: null, items: [{ to: '/admin', label: '노출 현황' }] },
  {
    group: '브랜드·계정',
    items: [
      { to: '/admin/brands', label: '브랜드' },
      { to: '/admin/signups', label: '가입 신청' },
      { to: '/admin/billing', label: '구독·결제' },
      { to: '/admin/report-messages', label: '보고서 발송' },
      { to: '/admin/users', label: '계정' },
      { to: '/admin/agencies', label: '대행사' },
    ],
  },
  {
    group: '측정',
    items: [
      { to: '/admin/queries', label: '질문 관리' },
      { to: '/admin/sites', label: '우리 사이트' },
      { to: '/admin/citations', label: '인용 도메인' },
      { to: '/admin/seo', label: '검색엔진 도달' },
      { to: '/admin/geo-cases', label: '인터뷰 준비' },
    ],
  },
  {
    group: '콘텐츠',
    items: [
      { to: '/admin/articles', label: '기사 작성' },
      { to: '/admin/contracts', label: '계약서' },
      { to: '/admin/videos', label: '영상 제작' },
    ],
  },
  {
    group: '수집',
    items: [
      { to: '/admin/health', label: '수집 상태' },
      { to: '/admin/workers', label: '워커' },
    ],
  },
] as const;
